"use strict";
/**
 * Product and Category Import/Export Types
 * Defines the structure for CSV-based import/export operations
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALIDATION_RULES = void 0;
// Default validation rules
exports.DEFAULT_VALIDATION_RULES = {
    requiredCategoryFields: ['name'],
    requiredProductFields: ['name', 'categoryId', 'variantName', 'price'],
    maxNameLength: 255,
    maxDescriptionLength: 1000,
    minPrice: 0,
    maxPrice: 999999999,
    categoryIdPattern: /^[a-zA-Z0-9_-]+$/,
    productIdPattern: /^[a-zA-Z0-9_-]+$/,
    variantIdPattern: /^[a-zA-Z0-9_-]+$/,
};
